import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';

const GoogleMap = ({ coordinatesArray }) => {
  const [map, setMap] = useState(null);
  const [markers, setMarkers] = useState([]);
  const [circle, setCircle] = useState(null);
  const [infoWindow, setInfoWindow] = useState(null);
  const [infoWindowOpen, setInfoWindowOpen] = useState(false);


  useEffect(() => {
    if (!window.google || !window.google.maps || !coordinatesArray || coordinatesArray.length === 0) return;

    const mapOptions = {
      zoom: 16,
      mapTypeId: 'satellite',
      center: { lat: coordinatesArray[coordinatesArray.length - 1].Latitude, lng: coordinatesArray[coordinatesArray.length - 1].Longitude },
    };

    const googleMap = new window.google.maps.Map(document.getElementById('map'), mapOptions);
    setMap(googleMap);

    const newMarkers = coordinatesArray.map((coordinate, index) => {
      const position = { lat: coordinate.Latitude, lng: coordinate.Longitude };
      const marker = new window.google.maps.Marker({
        position,
        map: googleMap,
        icon: index === coordinatesArray.length - 1 ? 'http://maps.google.com/mapfiles/ms/icons/red-dot.png' : 'http://maps.google.com/mapfiles/ms/icons/blue-dot.png',
        title: index === coordinate.Location
      });

      if (index === coordinatesArray.length - 1) {
        const infoWindow = new window.google.maps.InfoWindow({
          content: `<div>
                      <h3>${coordinate.Location === null ? index.toString() : coordinate.Location}</h3>
                      <p>Latitude: ${coordinate.Latitude}</p>
                      <p>Longitude: ${coordinate.Longitude}</p>
                      <p>No of Plots: ${coordinate.plantTationCount}</p>
                    </div>`
        });

        infoWindow.open(googleMap, marker);
        marker.addListener('click', () => {
          if (infoWindowOpen) {
            infoWindow.close();
            setInfoWindowOpen(false);
          } else {
            infoWindow.open(googleMap, marker);
            setInfoWindowOpen(true);
          }
        });
      } else {
        marker.addListener('click', () => {
          const infoWindow = new window.google.maps.InfoWindow({
            content: `<div>
                        <h3>${coordinate.Location === null ? index.toString() : coordinate.Location}</h3>
                        <p>Latitude: ${coordinate.Latitude}</p>
                        <p>Longitude: ${coordinate.Longitude}</p>
                        <p>No of Plants: ${coordinate.plantTationCount}</p>
                      </div>`
          });
          infoWindow.open(googleMap, marker);
        });

        setInterval(() => {
          marker.setAnimation(window.google.maps.Animation.BOUNCE);
          setTimeout(() => {
            marker.setAnimation(null);
          }, 700);
        }, 1000);
      }

      return marker;
    });

    setMarkers(newMarkers);

    const bounds = new window.google.maps.LatLngBounds();
    const lastCoordinate = coordinatesArray[coordinatesArray.length - 1];
    const position = { lat: lastCoordinate.Latitude, lng: lastCoordinate.Longitude };
    bounds.extend(position);
    bounds.extend(new window.google.maps.LatLng(position.lat - 0.01, position.lng));
    bounds.extend(new window.google.maps.LatLng(position.lat, position.lng - 0.01));
    const radius = window.google.maps.geometry.spherical.computeDistanceBetween(bounds.getCenter(), position);

    // const newCircle = new window.google.maps.Circle({
    //   strokeColor: '#FF0000',
    //   strokeOpacity: 0.8,
    //   strokeWeight: 2,
    //   fillColor: '#FF0000',
    //   fillOpacity: 0.35,
    //   map: googleMap,
    //   center: position,
    //   radius: radius
    // });
    // setCircle(newCircle);

  }, [coordinatesArray]);

  return <div id="map" style={{ height: '500px', width: '100%' }} />;
};

GoogleMap.propTypes = {
  coordinatesArray: PropTypes.arrayOf(
    PropTypes.shape({
      Latitude: PropTypes.number.isRequired,
      Longitude: PropTypes.number.isRequired,
      Location: PropTypes.string,
    })
  ).isRequired,
};

export default GoogleMap;
